import { Button, Image, Modal, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import AddNotificationModal from "./_AddNotificationModal";
// import AdvertisementBannerForm from "./AdvertisementBannerForm";

const { confirm } = Modal;

const PushNotificationManager = ({ sectionName }) => {
  const [pagination, setPagination] = useState({
    current: 1,
    total: 10,
  });

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedAddBanner, setSelectedAddBanner] = useState();
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const { request } = useRequest();

  const handleChange = (pagination, sorter, filters) => {
    if (!sorter) {
      setPagination((prev) => ({
        current: pagination.current,
        total: 10,
      }));
    }
  };

  const onDelete = (id) => {
    request({
      url: apiPath.notification + "/" + id,
      method: "POST",
      onSuccess: (data) => {
        ShowToast(data.message, Severty.SUCCESS)
        setLoading(false);
        setRefresh(prev => !prev)
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchData = () => {
    request({
      url:
        apiPath.notification +
        `?status=${""}&page=${pagination ? pagination.current : 1}&pageSize=${pagination && pagination?.total ? pagination?.total : 10
        }&search=${""}`,
      method: "GET",
      onSuccess: (data) => {
        setList(data.data);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };


  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (_, { title }) => title,
    },
    {
      title: "Notifications",
      dataIndex: "message",
      key: "message",
      width: 200,
      render: (_, { message }) => {
        const truncatedMessage = message?.length > 50
          ? `${message.substring(0, 50)}...`
          : message;

        return (
          <Tooltip title={message} placement="topLeft">
            <span style={{
              cursor: 'pointer',
              display: 'purple',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {truncatedMessage}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Sent By",
      dataIndex: "send_by",
      key: "send_by",
      render: (_, { send_by }) => {
        return send_by ? send_by?.name : "admin";
      },
    },
    {
      title: "Notification Type",
      dataIndex: "notification_type",
      key: "notification_type",
      render: (_, { notification_type }) => {
        return notification_type ? notification_type : "-";
      },
    },
    {
      title: "Delivery Status",
      dataIndex: "delivery_status",
      key: "delivery_status",
      render: (_, { delivery_status }) => {
        return delivery_status ? delivery_status : "-";
      },
    },
    {
      title: "Sent At",
      dataIndex: "created_at",
      key: "created_at",
      render: (_, { created_at }) => {
        return created_at ? moment(created_at).format("lll") : "-";
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                title="Delete"
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i class="fas fa-trash"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Resend" color="purple">
              <Button
                className="btnStyle primary_btn"
                onClick={() => {
  const isSelectAllUser = record.audience === "Customer" && (!record.users || record.users.length === 0);

  // 🛠️ Remove `_id`, `created_at`, etc. so we don't reuse them when resending
  const { _id, created_at, updated_at, ...rest } = record;

  setSelectedAddBanner({
    ...rest,
    isSelectAllUser,
    user_id: record?.users?.map((u) => u.user_id) || [],
  });

  setVisible(true);
}}

              >
                <i className="fas fa-paper-plane"></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData(pagination);
  }, [refresh]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }} className="main-new-notification-headekk">
        <h6>Push Notification</h6>
        <div className="w-100 text-head_right_cont">
          <Button
            className="primary_btn btnStyle"
            onClick={(e) => {
              setVisible(true);
            }}
          >
            <span className="add-Ic">
              <img src={Plus} />
            </span>
            Add Notification
          </Button>
        </div>
      </div>

      <div className="table-responsive customPagination">
        <Table
          loading={loading}
          columns={columns}
          dataSource={list}
          pagination={{
            defaultPageSize: 10,
            responsive: true,
            total: pagination.total,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "30", "50"],
          }}
          onChange={handleChange}
          className="ant-border-space"
        />
      </div>


      {visible && (
        <AddNotificationModal
          type={sectionName}
          sectionName={sectionName}
          show={visible}
          hide={() => {
            setSelectedAddBanner();
            setVisible(false);
          }}
          ant-btn-default
          data={selectedAddBanner}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {showDelete && (
        <DeleteModal
          title={"Delete Notification"}
          subtitle={`Are you sure you want to Delete this Notification?`}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
};

export default PushNotificationManager;
